// extracted by mini-css-extract-plugin
module.exports = {"socialContainer":"FooterSocial_socialContainer__xsOE3","poweredWrapper":"FooterSocial_poweredWrapper__SuFsg","iconsWrapper":"FooterSocial_iconsWrapper__7c0sX"};